module.exports = function (done, value) {
  return { value: value, done: !!done };
};



//////////////////
// WEBPACK FOOTER
// ./~/.2.5.1@core-js/library/modules/_iter-step.js
// module id = 266
// module chunks = 21